import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  width: 95%;
  height: 100%;
  justify-content: center;
  align-items: flex-start;
  margin: auto;
`
